import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/api/conditions', request, cancelToken)
}

export {get}
